import { createContext, useContext } from "react";

export interface ToastApi {
  push(title: string, description?: string, tone?: "success" | "danger"): void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used inside ToastProvider");
  return ctx;
}
